import React, { useState } from "react";
import { TextField, Box, Typography, Grid } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "./AnswerSetEight.css"; 
import { useDispatch } from "react-redux";
import { updateRelianceQAlist , selectReliancecheckedQuestion} from "../../redux/Slice";
import { useEffect } from "react";
import { useSelector } from "react-redux";



const AnswerSetEight = ({ pindex, qdata, parentqData ,
  updateRelianceQAlist,
  ReliancecheckedQuestion,
  setRelianceCheckedQuestio
}) => {
  const [des , setDes] = useState('');


  const dispatch = useDispatch();

  const handleClick = (event) => {
    event.stopPropagation();
  };

  const convertMMDate = (dateString) =>{
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getUTCFullYear();
  
    return `${month}/${year}`;
  }

  const [dataObj, setDataObj] = useState();

  // const ReliancecheckedQuestion = useSelector(selectReliancecheckedQuestion);

  console.log("the answer set one data",ReliancecheckedQuestion)

  console.log("the pindex", pindex);

  console.log("the q data in set one", qdata)




  useEffect(() => {
    if (ReliancecheckedQuestion) {

      console.log("hdfc checked question",ReliancecheckedQuestion )
      const keys = Object.keys(ReliancecheckedQuestion);
      const numbersToCheck = [9];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => ReliancecheckedQuestion[number.toString()]);


      console.log("the resultObjects", resultObjects) 
      let val;
      
 
      for (let key in resultObjects) {
        if (resultObjects[key].hasOwnProperty(pindex))
        {
          let data_one = resultObjects[key][pindex];
          // console.log("data_one",qdata.question_id)
          let val = data_one.find(item => item.Options[0].OptionId == qdata.QuestionSetCode );
          if (val != undefined)
          {
             console.log("val in for",val)
             let newobject = val;
             console.log("the newObject", newobject);
     
             if (newobject) {
     
               newobject.Options.map((item , index)=>{
                 if(item.OptionId == qdata.QuestionSetCode){
                  
                   
                     setDataObj(item);
                     return
                   }
               })
             }
          }
        }
     }

   
      
    }
  }, [ReliancecheckedQuestion]);

  console.log("the final data in set eight", dataObj);

  const normalizeDate = (dateString) => {

    if (dateString) {
      const [year, month, day] = dateString.split("/");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    
    }
  };
  const parseDate = (dateStr) => {
    const dateParts = dateStr.split('/');
    // Check if the parts are valid
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // month is 0-indexed
      const year = parseInt(dateParts[2], 10);
      return new Date(year, month, day);
    }
    return null; // Handle invalid date format
  };
 // useEffect to set the initial date if dataObj is present
//  useEffect(() => {
//   if (dataObj && dataObj.SufferingSince) {
//     const initialDate = parseDate(dataObj.SufferingSince);
//     if (initialDate) {
//       setSufferingSince(initialDate);

//     }
//     if(dataObj && dataObj.ConsultationDate){
//       let consultData = parseDate(dataObj.conConsultationDate)

//       if(consultData){
//         setConsultationDate(consultData)
//       }
//     }

  
   
//   }
// }, []);




  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box className="set-eight-body">
        {/* <Typography className='set-eight-body-title'>
          Q. Hypertension/ High blood pressure
        </Typography> */}

        <Grid
          container
          spacing={2}
          className="lower-set-eight-answers"
          style={{ paddingLeft: "0px" }}
        >
          <Grid item xs={12}>
            <TextField
              label="Description"
              type="text"
              fullWidth
              variant="standard"
              className="underline-textField"
              onClick={(e) => {
                handleClick(e);
              }}
              value={des ? des : dataObj?.HasChargedCancelledHighPremium || ""}
              onChange={(e) =>
               {setDes(e.target.value)
                // dispatch(
                  updateRelianceQAlist({
                    name: "HasChargedCancelledHighPremium",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  })
                // )
               }
              }
            />
          </Grid>
        </Grid>
      </Box>
    </LocalizationProvider>
  );
};

export default AnswerSetEight;
